import { v4 as generateUUID } from 'uuid';
import { Aggregation, Resolution, ResourceType, LicenseFeature } from '@/modules/shared/types';
import type { WidgetConfig } from '@/modules/ctx-dashboard';
import { WidgetType } from '@/modules/ctx-dashboard';
import type { WidgetPreset } from '@/components/widget-wizard';
import { Port } from '@/modules/shared/Port';
import Utils from '@/assets/js/utils/Utils';

export default class TimeChartProceedsAndCosts implements WidgetPreset {

    public readonly name: string = 'time-capital-service';
    public readonly requireLicenseFeatures: LicenseFeature[] = [LicenseFeature.ACCOUNTING];
    public readonly type: WidgetType = WidgetType.TimeChart;
    public readonly quickAdd: boolean = true;
    public readonly order: number = 60;
    public readonly hidden: boolean = true;
    public readonly metrics: string[] = [
        'b3fd39e8-2c0f-4488-a5db-3168792712dd',
        'eae0a73c-a9ce-467f-8171-ab104772a39f',
        '940e2080-4b65-4d64-8104-6399a5d48616',
    ];

    public async createWidget(params: { portfolio: string; dashboard: string }): Promise<WidgetConfig> {
        // TODO should be shareholder
        const resources = [{
            uuid: generateUUID().substring(0, 8),
            seriesName: '',
            resourceName: (await Port.portfolios.getPortfolioByKey(params.portfolio))?.name || '',
            type: ResourceType.Portfolio,
            resourceKey: params.portfolio,
            aggregationOverGenerators: Aggregation.Sum,
            config: {},
        }];
        return {
            key: '',
            portfolioKey: params.portfolio,
            dashboardKey: params.dashboard,
            order: 0,
            config: {},
            type: this.type,
            preset: this.name,
            title: '',
            generatedTitle: '',
            intervalName: 'this-year-complete',
            intervalTo: undefined,
            intervalFrom: undefined,
            resolution: Resolution.Monthly,
            axis: [{
                unit: '',
                name: '',
                config: {
                    type: 'area',
                },
                metrics: this.metrics.map((metricKey) => ({
                    uuid: generateUUID().substring(0, 8),
                    metricKey: metricKey,
                    metricName: '',
                    metricCategory: '',
                    metricUnit: '',
                    aggregationOverTime: Aggregation.Sum,
                    resources: Utils.deepCopy(resources),
                })),
            }, {
                unit: '',
                name: '',
                config: {
                    type: 'line',
                },
                metrics: [],
            }],
        };
    }
}
